import React, { useContext } from "react";
import { 
  Card, 
  CardContent, 
  TextField, 
  Typography, 
  Grid,
  InputAdornment,
  Divider
} from "@mui/material";
import { 
  Phone as PhoneIcon, 
  Person as PersonIcon,
  Contacts as ContactsIcon,
  People as RelationIcon
} from "@mui/icons-material";
import { Context } from "../../context";
import { MEDICAL_BILLING_PERSON } from "../../config";

const EmergencyContactField = ({
  label,
  name,
  value,
  updateEmergencyContact,
  painConsultNoteSigned,
  icon,
  placeholder,
  type = "text"
}) => {
  const { user } = useContext(Context);
  
  return (
    <TextField
      variant="outlined"
      size="small"
      fullWidth
      margin="dense"
      label={label}
      value={value || ""}
      name={name}
      onChange={(e) => updateEmergencyContact(e)}
      disabled={(user && user.role === MEDICAL_BILLING_PERSON) }
      placeholder={placeholder}
      type={type}
      InputProps={{
        startAdornment: icon ? (
          <InputAdornment position="start">
            {icon}
          </InputAdornment>
        ) : null
      }}
    />
  );
};

const EmergencyContact = ({
  emergencyContact,
  setEmergencyContact,
  painConsultNoteSigned,
}) => {
  const updateEmergencyContact = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setEmergencyContact((values) => ({ ...values, [name]: value }));
  };

  return (
    <Card elevation={2} sx={{ height: '100%' }}>
      <CardContent>
        <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
          <ContactsIcon sx={{ mr: 1 }} color="error" /> 
          Emergency Contact
        </Typography>
        
        <Divider sx={{ mb: 2 }} />
        
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <EmergencyContactField
              label="Contact Name"
              name="contact_name"
              value={emergencyContact.contact_name}
              updateEmergencyContact={updateEmergencyContact}
              painConsultNoteSigned={painConsultNoteSigned}
              icon={<PersonIcon color="error" fontSize="small" />}
              placeholder="Full name of emergency contact"
            />
          </Grid>
          
          <Grid item xs={12}>
            <EmergencyContactField
              label="Contact Number"
              name="contact_number"
              value={emergencyContact.contact_number}
              updateEmergencyContact={updateEmergencyContact}
              painConsultNoteSigned={painConsultNoteSigned}
              icon={<PhoneIcon color="error" fontSize="small" />}
              placeholder="(555) 123-4567"
              type="tel"
            />
          </Grid>
          
          <Grid item xs={12}>
            <EmergencyContactField
              label="Relationship to Patient"
              name="contact_relation"
              value={emergencyContact.contact_relation}
              updateEmergencyContact={updateEmergencyContact}
              painConsultNoteSigned={painConsultNoteSigned}
              icon={<RelationIcon color="error" fontSize="small" />}
              placeholder="Spouse, Parent, Child, etc."
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default EmergencyContact;